import { render, staticRenderFns } from "./UpdateAppointmentModal.vue?vue&type=template&id=3c2b8501&"
import script from "./UpdateAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAppointmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports